import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

export default async function emailInvoiceToPatient(invoiceNo: string) {
  const res = await fetchOrchidAPI(`/api/invoicing/email/${invoiceNo}`, {
    method: "POST",
  });
  if (!res.ok) {
    throw new Error(
      `failed to email invoice to patient: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
